import config from '../constants/config';
import { BigNumber } from 'ethers';
import { useContractRead } from 'wagmi';

const useClaimedHoneyForWallet = (
  address?: string
): [amount: BigNumber | undefined, read: () => void] => {
  const { data, refetch } = useContractRead({
    addressOrName: config.contracts.fancyBearStakingRewardContractV2.address,
    contractInterface:
      config.contracts.fancyBearStakingRewardContractV2.interface,
    functionName: 'claimedHoneyForWallets',
    args: address,
  });

  return [data ? (data as any as BigNumber) : undefined, refetch];
};

export default useClaimedHoneyForWallet;
